import React, { createContext, useState, useContext, useEffect  } from 'react';

// Context 생성
const UserContext = createContext();

// Provider 컴포넌트 생성
export const UserProvider = ({ children }) => {
  const [userInfo, setUserInfo] = useState(null);

  return (
    <UserContext.Provider value={{ userInfo, setUserInfo }}>
      {children}
    </UserContext.Provider>
  );
};

// Context 사용을 위한 Custom Hook
export const useUser = () => useContext(UserContext);